import React from "react";
import { Link } from "react-router-dom";
import { BROWSER_ROUTES } from "@constants/browser.routes";
import { getCopyrightText } from "@components/Footer/utils/getCopyright";
import { useTranslation } from "react-i18next";

export const Footer: React.FC = () => {
	const { t } = useTranslation();
	return (
		<footer className="bg-white border-t py-4 px-8 flex items-center justify-between text-sm ml-72">
			<div className="text-gray-500">{getCopyrightText(t("psdaCommon.footer.copyright"), t("psdaCommon.common.projectTitle"))}</div>
			<div className="space-x-2">
				<Link to={BROWSER_ROUTES.PRIVACY_POLICY} className="text-[#066235] hover:underline">
					{t("psdaCommon.footer.privacyPolicy")}
				</Link>
				<span className="text-gray-400">|</span>
				<Link to={BROWSER_ROUTES.TERMS_AND_CONDITIONS} className="text-[#066235] hover:underline">
					{t("psdaCommon.footer.termsOfService")}
				</Link>
			</div>
		</footer>
	);
};
